import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import { CustomStack, CustomTextField, SectionWrapper } from '@components/Styles/CommonStyle';
import { Stack, TableBody, Typography, IconButton } from '@mui/material';
import { CustomButton } from '@components/Styles/ButtonStyle';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { theme } from '@components/Styles/theme';
import { useLoading } from '@context/LoadingContext';
import api from '@api/axios';
import { FormProvider, useForm } from 'react-hook-form';
import { PROJECT_TYPE_OPTIONS } from '@constants/project';
import ControlledCheckBox from '@components/common/Input/ControlledCheckBox';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SectionToggle from '@components/common/Shared/SectionToggle';

const ProjectListTableSearchV2 = forwardRef(({ onSearch, getYearlyFinance, staticSearch, setStaticSearch }, ref) => {
  const methods = useForm();

  // 상대적으로 동적으로 관리되는 파라미터 (검색 파라미터)
  const [search, setSearch] = useState({
    projectName: '',
    orderingCompanyName: '',
    accountCompanyName: '',
    projectManagerName: '',
    staffName: '',
    status: '',
    orderBy: 'start_date',
    orderDir: 'ASC',
    isProjectConfirm: true,
    onlyFavorite: false,
  });

  const localStorageOpen = localStorage.getItem("검색");
  const [open, setOpen] = useState(localStorageOpen === null ? true : localStorageOpen === "true");

  useImperativeHandle(ref, () => ({
    getSearch: () => search,
    setSearch: (searchState) => {
      setSearch(searchState);
    },
  }));

  return (
    <React.Fragment>
      <SectionWrapper>
        <SectionToggle title="검색" open={open} setOpen={setOpen} sx={theme.typography.h4} />
        {open && (
          <FormProvider {...methods}>
            <CustomTableContainer>
              <CustomTable sixColumn>
                <TableBody>
                  <CustomTableRow>
                    <CustomHeaderCell>사업명</CustomHeaderCell>
                    <CustomBodyCell>
                      <CustomTextField
                        size="small"
                        placeholder="사업명"
                        value={search.projectName}
                        onChange={(e) => setSearch({ ...search, projectName: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            onSearch({page: 1, manualSearch: true, status: '', init: false});
                            getYearlyFinance(true);
                          }
                        }}
                      />
                    </CustomBodyCell>
                    <CustomHeaderCell>발주사</CustomHeaderCell>
                    <CustomBodyCell>
                      <CustomTextField
                        size="small"
                        placeholder="발주사"
                        value={search.orderingCompanyName}
                        onChange={(e) => setSearch({ ...search, orderingCompanyName: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            onSearch({page: 1, manualSearch: true, status: '', init: false});
                            getYearlyFinance(true);
                          }
                        }}
                      />
                    </CustomBodyCell>
                    <CustomHeaderCell>거래처</CustomHeaderCell>
                    <CustomBodyCell>
                      <CustomTextField
                        size="small"
                        placeholder="거래처"
                        value={search.accountCompanyName}
                        onChange={(e) => setSearch({ ...search, accountCompanyName: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            onSearch({page: 1, manualSearch: true, status: '', init: false});
                            getYearlyFinance(true);
                          }
                        }}
                      />
                    </CustomBodyCell>
                  </CustomTableRow>

                  <CustomTableRow>
                    <CustomHeaderCell>사업담당자</CustomHeaderCell>
                    <CustomBodyCell>
                      <CustomTextField
                        size="small"
                        placeholder="사업담당자"
                        value={search.projectManagerName}
                        onChange={(e) => setSearch({ ...search, projectManagerName: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            onSearch({page: 1, manualSearch: true, status: '', init: false});
                            getYearlyFinance(true);
                          }
                        }}
                      />
                    </CustomBodyCell>
                    <CustomHeaderCell>투입인력</CustomHeaderCell>
                    <CustomBodyCell>
                      <CustomTextField
                        size="small"
                        placeholder="투입인력"
                        value={search.staffName}
                        onChange={(e) => setSearch({ ...search, staffName: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            onSearch({page: 1, manualSearch: true, status: '', init: false});
                            getYearlyFinance(true);
                          }
                        }}
                      />
                    </CustomBodyCell>

                    <CustomHeaderCell>조회 조건</CustomHeaderCell>
                    <CustomBodyCell>
                      <ControlledCheckBox 
                        name={'projectType'} 
                        options={PROJECT_TYPE_OPTIONS}
                        onChangeFunc={(option, event) => {
                          console.log("onChangeFunc :: option.label");
                          console.log(option.label);
                          console.log("onChangeFunc :: event.target.checked");
                          console.log(event.target.checked);

                          if (option.label === '예정사업 포함') {
                            if (event.target.checked) {
                              setSearch({ ...search, isProjectConfirm: 'all' });
                              setStaticSearch({ ...staticSearch, isProjectConfirm: 'all' });
                            }
                            else {
                              setSearch({ ...search, isProjectConfirm: true });
                              setStaticSearch({ ...staticSearch, isProjectConfirm: true });
                            }
                          }
                          else if (option.label === '관심사업만') {
                            if (event.target.checked) {
                              setSearch({ ...search, onlyFavorite: true });
                              setStaticSearch({ ...staticSearch, onlyFavorite: true });
                            }
                            else {
                              setSearch({ ...search, onlyFavorite: false });
                              setStaticSearch({ ...staticSearch, onlyFavorite: false });
                            }
                          }
                        }}
                      />
                    </CustomBodyCell> 

                  </CustomTableRow>
                </TableBody>
              </CustomTable>
            </CustomTableContainer>
          </FormProvider>
        )}
        {open && (
          <CustomStack justifyContent="center" mt={2}>
            <CustomButton
              onClick={() => {
                onSearch({page: 1, manualSearch: true, status: '', init: false});
                getYearlyFinance(true);
              }}
            >
              검색
            </CustomButton>
          </CustomStack>
        )}
      </SectionWrapper>
    </React.Fragment>
  );
});

export default ProjectListTableSearchV2;
